import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingChat from "@/components/ChatWidget";
import FloatingContact from "@/components/FloatingContact";
import { Toaster } from "@/components/ui/sonner";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingChat />
      <FloatingContact />
      <Toaster position="top-right" richColors />
    </div>
  );
}
